<template>
  <header class="header">
    <!-- ログイン時 -->
    <nav v-if="login" class="navbar navbar-dark bg-dark navbar-expand-md">
        <router-link v-if="pageAdmin && loginUser.isAdmin" class="navbar-brand"  :to="'/admin/top'"></router-link>
        <router-link v-else class="navbar-brand"  :to="'/operator/top'"></router-link>
        
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- @manage管理者 -->
            <ul v-if="pageAtmanage" class="navbar-nav mr-auto mt-2 mt-md-0">
                <li class="nav-item" v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_READ','ROLE_YUKYU_ADMIN')">
                    <a class="nav-link" href="/atmanage/company/top">契約企業管理</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToAdminTop">戻る</a>
                </li>
            </ul>
            <!-- 企業管理者 -->
            <ul v-else-if="pageAdmin" class="navbar-nav mr-auto mt-2 mt-md-0">
                <li class="nav-item" v-if="hasAnyRole('ROLE_ADMIN','ROLE_YUKYU_READ','ROLE_YUKYU_ADMIN')">
                    <a class="nav-link" @click="goToLeaveRequestManage">休暇申請管理</a>
                </li>
                <li class="nav-item" v-if="hasAnyRole('ROLE_ADMIN','ROLE_KOTSUHI_READ','ROLE_KOTSUHI_ADMIN')">
                    <a class="nav-link" @click="goToKotsuhiManage">交通費管理</a>
                </li>
                <li class="nav-item" v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_READ','ROLE_WORK_ADMIN')">
                    <a class="nav-link" @click="goToWorkManage">勤怠管理</a>
                </li>
                <li class="nav-item" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_READ','ROLE_USER_ADMIN')">
                    <a class="nav-link" @click="goToUserManage">ユーザ管理</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToConfManage" v-if="hasAnyRole('ROLE_ADMIN','ROLE_MANAGE')">設定</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToOperatorTop">個人カレンダーをみる</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToAtmanageTop" v-if="hasAnyRole('ROLE_ATMANAGE')">システム管理</a>
                </li>
            </ul>
            <!-- オペレータ -->
            <ul v-else class="navbar-nav mr-auto mt-2 mt-md-0">
                <li class="nav-item">
                    <a class="nav-link" @click="goToOperatorTop">カレンダー</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToOperatorWork">勤務表</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToOperatorLeaveRequest" >休暇申請履歴</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToOperatorKotsuhiUnpaid">交通費履歴
                        <span v-if="unpaidCount > 0" class="badge badge-info badge-pill">
                            <span data-toggle="tooltip" data-placement="top" data-html="true" :title="unpaidCount + '件、未精算の交通費があります'">
                                {{unpaidCount}}
                            </span>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToOperatorSetting">個人設定</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="goToAdminTop" v-if="loginUser.isAdmin">管理画面に戻る</a>
                </li>
            </ul>
            <!-- ログアウト -->
            <div class="form-inline my-2 my-lg-0">
                <img class="card-img-top icon" :src="loginUser.imageUrl ? loginUser.imageUrl : ''" onerror="this.src='/src/assets/img/not_found_user_icon.jpg';">
                <p class="text-light m-1 my-2 my-sm-0">{{loginUser.userName}}</p>
                <button class="btn btn-outline-light my-2 my-sm-0" @click="logout">ログアウト</button>
            </div>
        </div>
    </nav>
  </header>
</template>

<style scoped>
.navbar .navbar-brand {
  background: url("../../img/logo.png") no-repeat left center;
  background-size: contain;
  height: 40px;
  width: 100px;
}
.icon {
  border-radius: 50%;
  height: 45px;
  width: 45px;
}
.nav-link {
  cursor: pointer;
}
</style>

<script>
import CommonAPI from '../api/common-api'
import KotsuhiAPI from '../api/kotsuhi-api'

export default {
  name: "asn-header",
  data() {
    return {
      login: false,
      ignorePage: ['/', '/login', '/sign-up', '/reset-password'],
      loginUser: {
        userName: '',
        isAdmin: false
      },
      pageAdmin: false,
      pageAtmanage: false,
      unpaidCount: 0
    }
  },
  watch: {
    // ページ遷移を監視
    '$route': function (to, from) {
      $('#navbarSupportedContent').removeClass('show');
      this.switchMenu(this.$route.path)
      if(!this.ignorePage.includes(to.path)){
        this.getLoginUser()
      }
    }
  },
  mounted () {
    this.switchMenu(this.$route.path)
    if(!this.ignorePage.includes(this.$route.path)){
      this.getLoginUser()
    }
  },
  methods: {
    // ヘッダのメニュー切り替え
    switchMenu (toPath) {
      if (toPath.startsWith('/admin')) {
        this.pageAdmin = true
        this.pageAtmanage = false
      } else if(toPath.startsWith('/atmanage')) {
        this.pageAtmanage = true
        this.pageAdmin = false
      } else {
        this.pageAtmanage = false
        this.pageAdmin = false
      }
    },
    // ログインスタッフ取得
    getLoginUser () {
      CommonAPI.getLoginUser()
          .then(res => {
            if (res == null) {
              this.login = false
              this.goToLogin()
            } else {
              this.login = true
              this.loginUser = res
            }
            if(this.pageAdmin == false && this.pageAtmanage == false){
                this.getUnpaidCount()
            }
          })
          .catch(err => {
            this.login = false
            this.goToLogin()
            console.error(err)
          })
    },
    // 未精算件数取得
    getUnpaidCount () {
        KotsuhiAPI.getUnpaidKotsuhiList(this.loginUser.userId)
            .then(res => {
                this.unpaidCount = res.length
            })
            .catch(err => {
                console.error(err)
            })
    },
    // ログアウト
    logout () {
      CommonAPI.logout()
          .then(res => {
            this.login = false
            this.$router.push('/login')
          })
          .catch(err => {
            console.error(err)
          })
    },
    goToLogin () {
      this.$router.push('/login')
    },
    goToSignUp () {
      this.$router.push('/sign-up')
    },
    goToLeaveRequestManage () {
      this.$router.push('/admin/leave-request/top')
    },
    goToKotsuhiManage () {
        this.$router.push('/admin/kotsuhi/top')
    },
    goToWorkManage () {
        this.$router.push('/admin/work/top')
    },
    goToUserManage () {
        this.$router.push('/admin/user/top')
    },
    goToConfManage () {
        this.$router.push('/admin/config/top')
    },
    goToAdminTop () {
        this.$router.push('/admin/top')
    },
    goToOperatorTop () {
        this.$router.push('/operator/top')
    },
    goToAtmanageTop () {
        this.$router.push('/atmanage/top')
    },
    goToOperatorWork () {
        this.$router.push('/operator/work/top')
    },
    goToOperatorLeaveRequest () {
        this.$router.push('/operator/leave-request/history')
    },
    goToOperatorKotsuhiUnpaid () {
        this.$router.push('/operator/kotsuhi/unpaid')
    },
    goToOperatorSetting () {
        this.$router.push('/operator/setting')
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
  },
  computed: {
    hasRole: function (role) {
      return true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/AsnHeader.vue